import Vue from "vue";

const state = {
    email: "",
    isDemo: 0,
    receiveMaintenanceEmail: "",
    webNotifications: "",
    mobileNotifications: "",
    emailNotifications: ""
};

const getters = {
    email: state => {
        return state.email;
    },

    isDemo: state => {
        return state.isDemo;
    },

    receiveMaintenanceEmail: state => {
        return state.receiveMaintenanceEmail;
    },

    webNotifications: state => {
        return state.webNotifications;
    },

    mobileNotifications: state => {
        return state.mobileNotifications;
    },

    emailNotifications: state => {
        return state.emailNotifications;
    }
};

const mutations = {
    setEmail(state, email) {
        state.email = email;
    },

    setIsDemo(state, isDemo) {
        state.isDemo = isDemo;
    },

    setReceiveMaintenanceEmail(state, value) {
        state.receiveMaintenanceEmail = value;
    },

    setWebNotifications(state, value) {
        state.webNotifications = value;
    },

    setMobileNotifications(state, value) {
        state.mobileNotifications = value;
    },

    setEmailNotifications(state, value) {
        state.emailNotifications = value;
    }
};

const actions = {
    async fetchUserSettings({commit, state}) {
        let response = await Vue.prototype.$axios.get('/user-settings');

        commit('setEmail', response.data.email);
        commit('setIsDemo', response.data.isDemo);
        commit('setReceiveMaintenanceEmail', response.data.receiveMaintenanceEmail);
        commit('setWebNotifications', response.data.webNotifications);
        commit('setMobileNotifications', response.data.mobileNotifications);
        commit('setEmailNotifications', response.data.emailNotifications);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};